import React from 'react'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { OktaTarget } from 'src/app/constants/constants'

interface ExpandedRowProps {
  targets: OktaTarget[]
}

export function ExpandedRow({ targets }: ExpandedRowProps) {
  const isEmptyOrInvalid =
    !targets ||
    targets.length === 0 ||
    !targets.some(
      (target) =>
        typeof target.alternateId === 'string' ||
        typeof target.displayName === 'string' ||
        typeof target.type === 'string' ||
        typeof target.detailEntry === 'string' // If it's sometimes an object, we’ll handle that below
    )

  if (isEmptyOrInvalid) {
    return <p className="p-3">No target data available.</p>
  }

  return (
    <div className="p-3">
      <h5>Target Details</h5>
      <DataTable value={targets} size="small" responsiveLayout="scroll">
        <Column field="alternateId" header="Alternate ID" />
        <Column field="displayName" header="Display Name" />
        <Column field="type" header="Type" />
        <Column
          field="detailEntry"
          header="Detail Entry"
          body={(rowData) =>
            typeof rowData.detailEntry === 'string'
              ? rowData.detailEntry
              : JSON.stringify(rowData.detailEntry) ?? '—'
          }
        />
      </DataTable>
    </div>
  )
}
